import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import RouteFeature from "../Features/RouteFeature";

export default class RouteLayer extends VectorLayer<VectorSource> {
  protected routeSource = new VectorSource();

  constructor(options?: any) {
    super(options);
    this.setSource(this.routeSource);
  }

  async showRoute(geometry: string) {
    this.routeSource.clear();
    this.routeSource.addFeature(new RouteFeature(geometry));
  }
}